import { render } from "./UpdateQwilrSubstitutionMapping.vue?vue&type=template&id=a9c37f3a&scoped=true"
import script from "./UpdateQwilrSubstitutionMapping.vue?vue&type=script&lang=js"
export * from "./UpdateQwilrSubstitutionMapping.vue?vue&type=script&lang=js"

import "./UpdateQwilrSubstitutionMapping.vue?vue&type=style&index=0&id=a9c37f3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c37f3a"]])

export default __exports__